export default __webpack_public_path__ + "static/media/light-hamburger.b163a0a5.svg";